import React from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthGuard } from "../App";
import { RoleGuard } from "../App";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTools, faSpinner, faCheckCircle } from "@fortawesome/free-solid-svg-icons"; // Added relevant icons
import { StandardURL } from "../App";


const UpdateMaintenancePage = () => {
  const navigate = useNavigate();

  const handleInProgressClick = () => {
    const requestId = localStorage.getItem("selectedMaintenanceRequestId");
    const token = localStorage.getItem("token");

    axios
      .patch(
        `${StandardURL}/iNyumba/maintenance/maintenance-requests/${requestId}/in-progress`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        toast.success(response.data.response);
        navigate(-1);
      })
      .catch((error) => {
        toast.error(error.response.data.response);
        console.error("Error updating maintenance request:", error);
      });
  };

  const handleCompletedClick = () => {
    const requestId = localStorage.getItem("selectedMaintenanceRequestId");
    const token = localStorage.getItem("token");

    axios
      .patch(
        `${StandardURL}/iNyumba/maintenance/maintenance-requests/${requestId}/completed`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        toast.success("Maintenance request marked as Completed!");
        navigate(-1);
      })
      .catch((error) => {
        toast.error("Error updating maintenance request!");
        console.error("Error updating maintenance request:", error);
      });
  };

    return (
    <RoleGuard>
      <AuthGuard>
        <div className="min-h-screen bg-gradient-to-br from-purple-50 to-indigo-100 p-4 sm:p-6 lg:p-8">
          <div className="max-w-xl mx-auto bg-white p-6 sm:p-8 rounded-xl shadow-2xl border border-gray-200">
            ---
            {/* --- Header Section --- */}
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
              <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight flex items-center">
                Update Maintenance Status <FontAwesomeIcon icon={faTools} className="ml-4 text-purple-600" />
              </h1>
            </div>

            <p className="text-gray-600 mb-8 text-center">
              Choose an action below to update the status of the maintenance request.
            </p>

            ---
            {/* --- Action Buttons Section --- */}
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <button
                onClick={handleInProgressClick}
                className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-lg font-semibold rounded-lg shadow-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-300 ease-in-out transform hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed"
                // disabled={isLoadingInProgress || isLoadingCompleted} // Commented out
              >
                {/* {isLoadingInProgress ? ( // Commented out
                  <FontAwesomeIcon icon={faSpinner} spin className="mr-3 text-white text-xl" />
                ) : ( */}
                  <FontAwesomeIcon icon={faTools} className="mr-3 text-white text-xl" />
                {/* )} */}
                {/* {isLoadingInProgress ? "Updating..." : "Mark as In Progress"} // Commented out */}
                Mark as In Progress
              </button>

              <button
                onClick={handleCompletedClick}
                className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-lg font-semibold rounded-lg shadow-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition duration-300 ease-in-out transform hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed"
                // disabled={isLoadingCompleted || isLoadingInProgress} // Commented out
              >
                {/* {isLoadingCompleted ? ( // Commented out
                  <FontAwesomeIcon icon={faSpinner} spin className="mr-3 text-white text-xl" />
                ) : ( */}
                  <FontAwesomeIcon icon={faCheckCircle} className="mr-3 text-white text-xl" />
                {/* )} */}
                {/* {isLoadingCompleted ? "Completing..." : "Mark as Completed"} // Commented out */}
                Mark as Completed
              </button>
            </div>
          </div>
        </div>
      </AuthGuard>
    </RoleGuard>
  );
};

export default UpdateMaintenancePage;
